import { render } from "./BusinessCardEdit.vue?vue&type=template&id=9e707cc8&scoped=true"
import script from "./BusinessCardEdit.vue?vue&type=script&lang=js"
export * from "./BusinessCardEdit.vue?vue&type=script&lang=js"

import "./BusinessCardEdit.vue?vue&type=style&index=0&id=9e707cc8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e707cc8"]])

export default __exports__